import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FiBarChart2,
  FiCheck,
  FiEye,
  FiEyeOff,
  FiLock,
  FiMail,
  FiShield,
  FiArrowRight,
  FiX,
  FiCheckCircle,
  FiSearch,
  FiFileText,
  FiServer,
  FiUserCheck,
  FiDatabase,
} from 'react-icons/fi';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';
import asderLogo from '../images/asderrLogo.png';
import kareKursBulvarLogo from '../images/karekursbluvar.png';

const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.asdersistem.karekursbulvar';
const APP_STORE_URL = 'https://apps.apple.com/tr/app/kare-kurs-bulvar/id6809610846?l=tr';

const ROLE_REDIRECT = {
  kurucu: '/admin/dashboard',
  ogrenci_isleri: '/admin/dashboard',
  ogretmen: '/ogretmen/dashboard',
  rehber_ogretmen: '/rehber/dashboard',
  veli: '/veli/dashboard',
  ogrenci: '/ogrenci/dashboard',
  muhasebe: '/muhasebe/dashboard',
};

function KareKursVipLogo({ small = false, compact = false }) {
  return (
    <img
      src={kareKursBulvarLogo}
      alt="Kare Kurs Vip Bulvar Logo"
      style={{
        width: compact ? 138 : small ? 210 : 335,
        maxWidth: '100%',
        height: 'auto',
        display: 'block',
        mixBlendMode: 'multiply',
      }}
    />
  );
}

function AsderBrand({ small = false, compact = false }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: compact ? 8 : small ? 12 : 20 }}>
      <img
        src={asderLogo}
        alt="ASDER Sistem Logo"
        style={{
          width: compact ? 42 : small ? 64 : 82,
          height: compact ? 42 : small ? 64 : 82,
          objectFit: 'contain',
          filter: 'drop-shadow(0 10px 18px rgba(2,22,62,0.12))',
          flexShrink: 0,
        }}
      />
      <div>
        <div style={{
          color: '#0d63f3',
          fontFamily: 'var(--font-ui)',
          fontSize: compact ? 14 : small ? 18 : 22,
          fontWeight: 900,
          letterSpacing: '-0.02em',
          lineHeight: 1.05,
          whiteSpace: 'nowrap',
        }}>
          ASDER Sistem
        </div>
        <div style={{
          marginTop: compact ? 4 : small ? 8 : 9,
          color: '#496084',
          fontSize: compact ? 7.5 : small ? 9 : 11,
          fontWeight: 800,
          letterSpacing: compact ? '0.05em' : '0.09em',
          textTransform: 'uppercase',
          lineHeight: 1.15,
        }}>
          Akademik Yönetim Sistemi
        </div>
      </div>
    </div>
  );
}

function StoreDownloadBadges({ compact = false }) {
  const badgeBaseStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: compact ? 9 : 10,
    padding: compact ? '9px 12px' : '10px 16px',
    borderRadius: 12,
    background: 'linear-gradient(135deg, #061844 0%, #0d2b6b 100%)',
    color: '#ffffff',
    textDecoration: 'none',
    border: '1px solid rgba(255, 255, 255, 0.14)',
    boxShadow: '0 10px 24px rgba(6, 24, 68, 0.16)',
    transition: 'transform 0.18s ease, box-shadow 0.18s ease',
    flex: 1,
    minWidth: compact ? 132 : 165,
    justifyContent: 'center',
  };

  return (
    <div style={{ width: '100%' }}>
      <div style={{
        fontSize: 11.5,
        fontWeight: 800,
        color: '#496084',
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
        marginBottom: 10,
        textAlign: compact ? 'center' : 'left',
      }}>
        Mobil Uygulamamızı İndirin
      </div>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        gap: 10,
      }}>
        <a
          href={PLAY_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={badgeBaseStyle}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 14px 28px rgba(6, 24, 68, 0.24)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 10px 24px rgba(6, 24, 68, 0.16)';
          }}
        >
          <svg width={compact ? 20 : 22} height={compact ? 20 : 22} viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0 }}>
            <path d="M3.61 1.814L13.793 12 3.61 22.186a1.1 1.1 0 0 1-.41-.857V2.671c0-.345.156-.656.41-.857z" fill="#32BBFF" />
            <path d="M17.205 8.588L13.793 12 3.61 1.814c.28-.222.68-.266 1.077-.04l12.518 6.814z" fill="#00E676" />
            <path d="M17.205 15.412L4.687 22.226c-.397.226-.797.182-1.077-.04L13.793 12l3.412 3.412z" fill="#FF3D00" />
            <path d="M20.805 10.548c.793.431.793 1.473 0 1.904l-3.6 1.96L13.793 12l3.412-3.412 3.6 1.96z" fill="#FFC107" />
          </svg>
          <div style={{ textAlign: 'left', lineHeight: 1.15 }}>
            <div style={{ fontSize: 9, fontWeight: 600, color: 'rgba(255,255,255,0.78)', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
              İndirin
            </div>
            <div style={{ fontSize: compact ? 12.5 : 13.5, fontWeight: 800, color: '#ffffff', whiteSpace: 'nowrap' }}>
              Google Play
            </div>
          </div>
        </a>

        <a
          href={APP_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={badgeBaseStyle}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 14px 28px rgba(6, 24, 68, 0.24)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 10px 24px rgba(6, 24, 68, 0.16)';
          }}
        >
          <svg width={compact ? 20 : 22} height={compact ? 20 : 22} viewBox="0 0 24 24" fill="currentColor" style={{ flexShrink: 0 }}>
            <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M15.97 6.33c.64-.78 1.08-1.86.96-2.94-.93.04-2.06.62-2.72 1.4-.58.68-1.1 1.79-.96 2.84 1.04.08 2.08-.52 2.72-1.3z" />
          </svg>
          <div style={{ textAlign: 'left', lineHeight: 1.15 }}>
            <div style={{ fontSize: 9, fontWeight: 600, color: 'rgba(255,255,255,0.78)', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
              İndirin
            </div>
            <div style={{ fontSize: compact ? 12.5 : 13.5, fontWeight: 800, color: '#ffffff', whiteSpace: 'nowrap' }}>
              App Store
            </div>
          </div>
        </a>
      </div>
    </div>
  );
}

const PRIVACY_SECTIONS = [
  {
    id: 'veri-sorumlusu',
    title: '1. Veri Sorumlusu ve Kapsam',
    badge: 'Yasal Dayanak',
    content: (
      <div>
        <p style={{ margin: '0 0 10px', lineHeight: 1.7, color: '#334155', fontSize: 14 }}>
          6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") ve ilgili mevzuat uyarınca; <strong>ASDER Sistem</strong> ve <strong>Kare Kurs Bulvar Özel Öğretim Kurumları</strong> ("Kurum"), veri sorumlusu sıfatıyla eğitim platformumuzdaki kişisel verilerinizi güvenle ve mevzuata tam uyumlu biçimde işlemektedir.
        </p>
        <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 12, padding: '14px 16px', marginTop: 10 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: '#0f172a', marginBottom: 6 }}>Kurum & Veri Sorumlusu Bilgileri:</div>
          <ul style={{ margin: 0, paddingLeft: 18, color: '#475569', fontSize: 13, lineHeight: 1.8 }}>
            <li><strong>Veri Sorumlusu:</strong> ASDER Sistem & Kare Kurs Bulvar Akademik Yönetim Birimi</li>
            <li><strong>Yasal Kapsam:</strong> 6698 Sayılı KVKK, Millî Eğitim Bakanlığı (MEB) Özel Öğretim Kurumları Mevzuatı</li>
            <li><strong>İletişim E-Posta:</strong> <a href="mailto:kvkk@karekursbulvar.com" style={{ color: '#0d63f3', fontWeight: 600 }}>kvkk@karekursbulvar.com</a> / <a href="mailto:destek@asdersistem.com" style={{ color: '#0d63f3', fontWeight: 600 }}>destek@asdersistem.com</a></li>
            <li><strong>Adres:</strong> Kare Kurs Bulvar Kampüsü, Özel Öğretim ve Akademik Koordinasyon Merkezi</li>
          </ul>
        </div>
      </div>
    ),
  },
  {
    id: 'toplanan-veriler',
    title: '2. İşlenen Kişisel Veriler ve Veri Kategorileri',
    badge: 'Detaylı Envanter',
    content: (
      <div>
        <p style={{ margin: '0 0 10px', lineHeight: 1.7, color: '#334155', fontSize: 14 }}>
          Eğitim-öğretim faaliyetlerinin, akademik ölçme-değerlendirme süreçlerinin ve kurum içi güvenliğin sağlanması amacıyla aşağıdaki veri kategorileri işlenmektedir:
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 12, marginTop: 12 }}>
          <div style={{ background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 12, padding: '12px 14px' }}>
            <div style={{ fontWeight: 800, color: '#1d4ed8', fontSize: 13.5, marginBottom: 4 }}>🆔 Kimlik Verileri</div>
            <div style={{ color: '#334155', fontSize: 12.5, lineHeight: 1.6 }}>Ad, soyad, T.C. Kimlik Numarası, doğum tarihi, cinsiyet, vesikalık profil fotoğrafı ve öğrenci numarası.</div>
          </div>
          <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 12, padding: '12px 14px' }}>
            <div style={{ fontWeight: 800, color: '#15803d', fontSize: 13.5, marginBottom: 4 }}>📞 İletişim Verileri</div>
            <div style={{ color: '#334155', fontSize: 12.5, lineHeight: 1.6 }}>Öğrenci ve veli cep telefonu, e-posta adresi, ikamet/tebligat adresi, acil durum irtibat bilgisi.</div>
          </div>
          <div style={{ background: '#fef3c7', border: '1px solid #fde68a', borderRadius: 12, padding: '12px 14px' }}>
            <div style={{ fontWeight: 800, color: '#b45309', fontSize: 13.5, marginBottom: 4 }}>📚 Eğitim & Akademik Veriler</div>
            <div style={{ color: '#334155', fontSize: 12.5, lineHeight: 1.6 }}>Kayıtlı sınıf/şube, deneme sınavı sonuçları (LGS, YKS, TYT, AYT), soru analizleri, başarı sıralamaları, net gelişim grafikleri, ödev ve etüt kayıtları.</div>
          </div>
          <div style={{ background: '#f5f3ff', border: '1px solid #ddd6fe', borderRadius: 12, padding: '12px 14px' }}>
            <div style={{ fontWeight: 800, color: '#6d28d9', fontSize: 13.5, marginBottom: 4 }}>⏱️ Devamsızlık & Turnike Logları</div>
            <div style={{ color: '#334155', fontSize: 12.5, lineHeight: 1.6 }}>RFID/kartlı geçiş zamanları, ders yoklamaları, geç kalma, izin ve hekim raporu kayıtları, veli SMS bildirim izleri.</div>
          </div>
          <div style={{ background: '#ecfeff', border: '1px solid #a5f3fc', borderRadius: 12, padding: '12px 14px' }}>
            <div style={{ fontWeight: 800, color: '#0e7490', fontSize: 13.5, marginBottom: 4 }}>🧠 Rehberlik & Gelişim Verileri</div>
            <div style={{ color: '#334155', fontSize: 12.5, lineHeight: 1.6 }}>Birebir rehberlik görüşme notları, ders çalışma programları, hedef analizleri (özel nitelikli veri hassasiyetinde korunur).</div>
          </div>
          <div style={{ background: '#fff1f2', border: '1px solid #fecdd3', borderRadius: 12, padding: '12px 14px' }}>
            <div style={{ fontWeight: 800, color: '#be123c', fontSize: 13.5, marginBottom: 4 }}>💳 Finansal & Muhasebe Verileri</div>
            <div style={{ color: '#334155', fontSize: 12.5, lineHeight: 1.6 }}>Eğitim sözleşmesi, taksit vadeleri ve tahsilat makbuzları. <em>(Kredi kartı ve CVV bilgileri veritabanında ASLA saklanmaz).</em></div>
          </div>
        </div>
      </div>
    ),
  },
  {
    id: 'isleme-amaclari',
    title: '3. Kişisel Verilerin İşlenme Amaçları ve Hukuki Sebepleri',
    badge: 'Amaç & Hukuk',
    content: (
      <div>
        <p style={{ margin: '0 0 10px', lineHeight: 1.7, color: '#334155', fontSize: 14 }}>
          Kişisel verileriniz, 6698 sayılı Kanun’un 5. ve 6. maddelerinde öngörülen hukuki sebeplerle ve aşağıdaki meşru amaçlarla işlenmektedir:
        </p>
        <ul style={{ margin: '8px 0', paddingLeft: 20, color: '#334155', fontSize: 13.5, lineHeight: 1.8 }}>
          <li><strong>Eğitim-Öğretim Süreçlerinin Yürütülmesi:</strong> Ders programlarının hazırlanması, etüt ve birebir ders organizasyonu, ödev dağıtımı ve takibi.</li>
          <li><strong>Akademik Başarı Ölçme ve Değerlendirme:</strong> Deneme sınavı sonuçlarının analizi, öğrencinin zayıf ve güçlü kazanımlarının tespiti ve veliye gelişim raporu sunulması.</li>
          <li><strong>Öğrenci Güvenliği ve Yoklama Takibi:</strong> Dershane giriş-çıkışlarının kontrolü, devamsızlıkların tespiti ve veliye anında bilgilendirme iletilmesi.</li>
          <li><strong>Hukuki ve İdari Yükümlülükler:</strong> MEB Özel Öğretim Kurumları Mevzuatı ve Vergi Usul Kanunu kapsamındaki yasal bildirimlerin eksiksiz yapılması.</li>
          <li><strong>Sistem Güvenliği:</strong> Platformun yetkisiz erişimlere, siber saldırılara ve veri ihlallerine karşı korunması, işlem güvenliğinin denetlenmesi.</li>
        </ul>
      </div>
    ),
  },
  {
    id: 'veri-aktarimi',
    title: '4. Verilerin Aktarımı ve Üçüncü Kişilerle Paylaşım',
    badge: 'Gizlilik Taahhüdü',
    content: (
      <div>
        <div style={{ background: '#f8fafc', borderLeft: '4px solid #0d63f3', padding: '14px 16px', borderRadius: '0 12px 12px 0', marginBottom: 12 }}>
          <strong style={{ color: '#0d63f3', fontSize: 14 }}>Ticari Paylaşım Yasağı:</strong>
          <p style={{ margin: '4px 0 0', color: '#475569', fontSize: 13, lineHeight: 1.6 }}>
            Toplanan kişisel veriler hiçbir surette ticari, reklam, pazarlama veya menfaat sağlama amacıyla üçüncü taraflarla paylaşılmaz, satılmaz veya kiralanamaz.
          </p>
        </div>
        <p style={{ lineHeight: 1.7, color: '#334155', fontSize: 14, margin: '8px 0' }}>
          Kişisel verileriniz yalnızca aşağıdaki hallerde ve yasal sınırlar dahilinde aktarılabilir:
        </p>
        <ul style={{ margin: '8px 0', paddingLeft: 20, color: '#334155', fontSize: 13.5, lineHeight: 1.8 }}>
          <li><strong>Yetkili Kamu Kurumları:</strong> MEB, savcılıklar, mahkemeler ve kanunen yetkili kılınmış resmi mercilere talep ve yasal zorunluluk halinde.</li>
          <li><strong>Teknik Altyapı Sağlayıcıları:</strong> SMS gönderim operatörleri ve güvenli sunucu sağlayıcılarına yalnızca hizmetin yerine getirilmesi amacıyla ve sıkı Veri İşleyen Sözleşmeleri kapsamında.</li>
        </ul>
      </div>
    ),
  },
  {
    id: 'veri-guvenligi',
    title: '5. Veri Güvenliği, Şifreleme ve Alınan Tedbirler',
    badge: 'Yüksek Güvenlik',
    content: (
      <div>
        <p style={{ margin: '0 0 10px', lineHeight: 1.7, color: '#334155', fontSize: 14 }}>
          Sistemimiz, kullanıcı verilerini en üst düzeyde korumak amacıyla uluslararası siber güvenlik standartlarında teknik ve idari tedbirlerle donatılmıştır:
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(230px, 1fr))', gap: 12, marginTop: 12 }}>
          <div style={{ padding: '14px', borderRadius: 12, border: '1px solid #e2e8f0', background: '#fafbfc' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#0d63f3', fontWeight: 800, fontSize: 13.5 }}>
              <FiLock /> 256-Bit SSL/TLS Şifreleme
            </div>
            <div style={{ marginTop: 6, color: '#64748b', fontSize: 12.5, lineHeight: 1.5 }}>
              Tüm ağ iletişimi A+ dereceli SSL şifreleme ile güvence altındadır; veriler ağ üzerinde açık metin olarak iletilmez.
            </div>
          </div>
          <div style={{ padding: '14px', borderRadius: 12, border: '1px solid #e2e8f0', background: '#fafbfc' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#059669', fontWeight: 800, fontSize: 13.5 }}>
              <FiUserCheck /> Rol Tabanlı Erişim (RBAC)
            </div>
            <div style={{ marginTop: 6, color: '#64748b', fontSize: 12.5, lineHeight: 1.5 }}>
              7 farklı kullanıcı rolü tanımlanmıştır. Öğretmen, veli veya öğrenci yalnızca kendi yetki alanındaki sınırlı veriyi görebilir.
            </div>
          </div>
          <div style={{ padding: '14px', borderRadius: 12, border: '1px solid #e2e8f0', background: '#fafbfc' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#d97706', fontWeight: 800, fontSize: 13.5 }}>
              <FiServer /> Kriptografik Parola Güvenliği
            </div>
            <div style={{ marginTop: 6, color: '#64748b', fontSize: 12.5, lineHeight: 1.5 }}>
              Şifreler tek yönlü tuzlanmış kriptografik hash algoritmalarıyla korunur; sistem yöneticileri dahil kimse şifreleri göremez.
            </div>
          </div>
          <div style={{ padding: '14px', borderRadius: 12, border: '1px solid #e2e8f0', background: '#fafbfc' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#dc2626', fontWeight: 800, fontSize: 13.5 }}>
              <FiDatabase /> Günlükleme ve Düzenli Yedek
            </div>
            <div style={{ marginTop: 6, color: '#64748b', fontSize: 12.5, lineHeight: 1.5 }}>
              Tüm kritik veri hareketleri zaman damgalı loglanır; veri kaybını önlemek amacıyla veritabanı düzenli aralıklarla yedeklenir.
            </div>
          </div>
        </div>
      </div>
    ),
  },
  {
    id: 'cerezler',
    title: '6. Çerez (Cookie) ve Oturum Politikası',
    badge: 'Çerezler',
    content: (
      <div>
        <p style={{ margin: '0 0 10px', lineHeight: 1.7, color: '#334155', fontSize: 14 }}>
          ASDER Sistem web arayüzünde yalnızca oturum güvenliğinin sağlanması ve kullanıcının kimlik doğrulamasının sürdürülebilmesi için teknik olarak <strong>zorunlu oturum çerezleri (Session Cookies ve JWT Token)</strong> kullanılmaktadır.
        </p>
        <p style={{ margin: 0, lineHeight: 1.7, color: '#334155', fontSize: 14 }}>
          Sistemimizde üçüncü taraf reklam, profil çıkarma, izleme veya davranışsal pazarlama çerezleri <strong>kesinlikle kullanılmamaktadır</strong>.
        </p>
      </div>
    ),
  },
  {
    id: 'saklama-imha',
    title: '7. Verilerin Saklanma Süresi ve Güvenli İmhası',
    badge: 'Saklama & İmha',
    content: (
      <div>
        <p style={{ margin: '0 0 10px', lineHeight: 1.7, color: '#334155', fontSize: 14 }}>
          Kişisel verileriniz, ilgili yasal mevzuatta belirlenen zorunlu saklama süreleri boyunca (MEB arşiv mevzuatı, Türk Ticaret Kanunu uyarınca mali belgeler için 10 yıl) muhafaza edilir.
        </p>
        <p style={{ margin: 0, lineHeight: 1.7, color: '#334155', fontSize: 14 }}>
          Yasal saklama süresi dolduğunda veya işleme amacı ortadan kalktığında verileriniz, <em>Kişisel Verilerin Silinmesi, Yok Edilmesi veya Anonim Hale Getirilmesi Hakkında Yönetmelik</em> hükümleri uyarınca güvenli yöntemlerle geri döndürülemez şekilde silinir, yok edilir veya anonimleştirilir.
        </p>
      </div>
    ),
  },
  {
    id: 'ilgili-kisi-haklari',
    title: '8. İlgili Kişinin Hakları (KVKK Madde 11)',
    badge: 'Kanuni Haklarınız',
    content: (
      <div>
        <p style={{ margin: '0 0 10px', lineHeight: 1.7, color: '#334155', fontSize: 14 }}>
          KVKK’nın 11. maddesi uyarınca veri sahibi olarak Kurumumuza başvurarak aşağıdaki haklarınızı kullanabilirsiniz:
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 10, marginTop: 10 }}>
          {[
            'Kişisel verilerinizin işlenip işlenmediğini öğrenme',
            'Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme',
            'İşlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme',
            'Yurt içinde veya yurt dışında kişisel verilerin aktarıldığı üçüncü kişileri bilme',
            'Eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme',
            'KVKK m. 7 çerçevesinde kişisel verilerin silinmesini veya yok edilmesini isteme',
            'Düzeltme ve silme işlemlerinin verilerin aktarıldığı 3. kişilere bildirilmesini isteme',
            'İşlenen verilerin münhasıran otomatik analiz edilmesiyle aleyhe bir sonucun çıkmasına itiraz etme',
            'Kanuna aykırı işleme sebebiyle zarara uğramanız hâlinde zararın giderilmesini talep etme',
          ].map((hak, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 8, padding: '9px 12px', background: '#f8fafc', borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 12.5, color: '#334155' }}>
              <FiCheckCircle style={{ color: '#0d63f3', marginTop: 2, flexShrink: 0, fontSize: 15 }} />
              <span><strong>Madde 11/{String.fromCharCode(97 + i)}:</strong> {hak}</span>
            </div>
          ))}
        </div>
      </div>
    ),
  },
  {
    id: 'basvuru-iletisim',
    title: '9. Başvuru Usulü ve İletişim',
    badge: 'İletişim & Başvuru',
    content: (
      <div>
        <p style={{ margin: '0 0 10px', lineHeight: 1.7, color: '#334155', fontSize: 14 }}>
          KVKK kapsamındaki haklarınıza ilişkin taleplerinizi, kimliğinizi tespit edici gerekli belgeler ile birlikte aşağıdaki kanallardan iletebilirsiniz:
        </p>
        <div style={{ background: 'linear-gradient(135deg, #f0f7ff, #e6f0fd)', border: '1px solid #bfdbfe', borderRadius: 14, padding: '16px 20px', marginTop: 10 }}>
          <div style={{ color: '#0d63f3', fontWeight: 800, fontSize: 14, marginBottom: 8 }}>Başvuru Kanalları:</div>
          <p style={{ margin: '4px 0', fontSize: 13, color: '#1e3a8a', lineHeight: 1.6 }}>
            ✉️ <strong>E-Posta:</strong> <a href="mailto:kvkk@karekursbulvar.com" style={{ color: '#0d63f3', fontWeight: 700 }}>kvkk@karekursbulvar.com</a> (Kayıtlı e-posta adresinizden)
          </p>
          <p style={{ margin: '4px 0', fontSize: 13, color: '#1e3a8a', lineHeight: 1.6 }}>
            📍 <strong>Yazılı Başvuru:</strong> Kare Kurs Bulvar Özel Öğretim Kurumları, Veri Sorumlusu İrtibat Birimi adresine ıslak imzalı dilekçe ile şahsen veya noter kanalıyla.
          </p>
          <p style={{ margin: '10px 0 0', fontSize: 12.5, color: '#2563eb' }}>
            Talepleriniz, kanunun 13. maddesi gereğince niteliğine göre en kısa sürede ve en geç <strong>30 (otuz) gün</strong> içinde ücretsiz olarak sonuçlandırılacaktır.
          </p>
        </div>
      </div>
    ),
  },
];

function PrivacyModal({ isOpen, onClose }) {
  const [activeTab, setActiveTab] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    if (!isOpen) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKeyDown);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = prevOverflow;
    };
  }, [isOpen, onClose]);

  const filteredSections = useMemo(() => {
    let list = PRIVACY_SECTIONS;
    if (activeTab !== 'all') {
      list = list.filter((s) => s.id === activeTab);
    }
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      list = list.filter(
        (s) =>
          s.title.toLowerCase().includes(q) ||
          s.badge.toLowerCase().includes(q) ||
          s.id.toLowerCase().includes(q)
      );
    }
    return list;
  }, [activeTab, searchQuery]);

  if (!isOpen) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(6, 24, 68, 0.65)',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '16px',
        animation: 'privacyFadeIn 0.2s ease',
      }}
    >
      <style>{`
        @keyframes privacyFadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes privacySlideUp {
          from { opacity: 0; transform: translateY(16px) scale(0.98); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }
        .privacy-scroll::-webkit-scrollbar {
          width: 8px;
        }
        .privacy-scroll::-webkit-scrollbar-track {
          background: #f1f5f9;
        }
        .privacy-scroll::-webkit-scrollbar-thumb {
          background: #cbd5e1;
          border-radius: 4px;
        }
        .privacy-scroll::-webkit-scrollbar-thumb:hover {
          background: #94a3b8;
        }
      `}</style>

      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: '#ffffff',
          borderRadius: 20,
          boxShadow: '0 24px 64px rgba(6, 24, 68, 0.28)',
          border: '1px solid rgba(210, 222, 238, 0.9)',
          width: '100%',
          maxWidth: 820,
          maxHeight: '90vh',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          animation: 'privacySlideUp 0.25s cubic-bezier(0.16, 1, 0.3, 1)',
        }}
      >
        {/* Modal Header */}
        <div
          style={{
            padding: '20px 24px 16px',
            borderBottom: '1px solid #e2e8f0',
            background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)',
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            gap: 16,
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
            <div
              style={{
                width: 46,
                height: 46,
                borderRadius: 12,
                background: 'linear-gradient(135deg, #0d63f3, #0b4ec2)',
                color: '#fff',
                display: 'grid',
                placeItems: 'center',
                fontSize: 22,
                boxShadow: '0 8px 18px rgba(13, 99, 243, 0.28)',
                flexShrink: 0,
              }}
            >
              <FiShield />
            </div>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                <h3
                  style={{
                    margin: 0,
                    fontSize: 19,
                    fontWeight: 900,
                    color: '#061844',
                    letterSpacing: '-0.02em',
                  }}
                >
                  Gizlilik Sözleşmesi ve KVKK Aydınlatma Metni
                </h3>
                <span
                  style={{
                    background: '#e0f2fe',
                    color: '#0369a1',
                    fontSize: 11,
                    fontWeight: 800,
                    padding: '2px 8px',
                    borderRadius: 999,
                    border: '1px solid #bae6fd',
                  }}
                >
                  6698 KVKK & MEB Uyumlu
                </span>
              </div>
              <div style={{ marginTop: 4, color: '#64748b', fontSize: 13, fontWeight: 500 }}>
                ASDER Sistem & Kare Kurs Bulvar Akademik Yönetim Platformu
              </div>
            </div>
          </div>

          <button
            type="button"
            onClick={onClose}
            aria-label="Kapat"
            style={{
              background: '#f1f5f9',
              border: 'none',
              borderRadius: 10,
              width: 36,
              height: 36,
              display: 'grid',
              placeItems: 'center',
              cursor: 'pointer',
              color: '#475569',
              fontSize: 18,
              transition: 'all 0.15s ease',
              flexShrink: 0,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#e2e8f0';
              e.currentTarget.style.color = '#0f172a';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = '#f1f5f9';
              e.currentTarget.style.color = '#475569';
            }}
          >
            <FiX />
          </button>
        </div>

        {/* Search & Navigation Filter Bar */}
        <div
          style={{
            padding: '12px 24px',
            borderBottom: '1px solid #eef2f6',
            background: '#ffffff',
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
          }}
        >
          {/* Quick Search */}
          <div style={{ position: 'relative' }}>
            <FiSearch
              style={{
                position: 'absolute',
                left: 12,
                top: '50%',
                transform: 'translateY(-50%)',
                color: '#94a3b8',
                fontSize: 15,
              }}
            />
            <input
              type="text"
              placeholder="Sözleşme içinde ara (örn: veli, rehberlik, sınav, şifre, haklar)..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={{
                width: '100%',
                height: 38,
                paddingLeft: 36,
                paddingRight: searchQuery ? 32 : 12,
                borderRadius: 10,
                border: '1px solid #cbd5e1',
                fontSize: 13,
                outline: 'none',
                background: '#f8fafc',
                boxSizing: 'border-box',
              }}
            />
            {searchQuery && (
              <button
                type="button"
                onClick={() => setSearchQuery('')}
                style={{
                  position: 'absolute',
                  right: 8,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'none',
                  border: 'none',
                  color: '#94a3b8',
                  cursor: 'pointer',
                  fontSize: 14,
                }}
              >
                ✕
              </button>
            )}
          </div>

          {/* Category Chips */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              overflowX: 'auto',
              paddingBottom: 4,
              scrollbarWidth: 'none',
            }}
          >
            <button
              type="button"
              onClick={() => setActiveTab('all')}
              style={{
                padding: '5px 12px',
                borderRadius: 20,
                fontSize: 12,
                fontWeight: 700,
                border: 'none',
                cursor: 'pointer',
                whiteSpace: 'nowrap',
                transition: 'all 0.15s ease',
                background: activeTab === 'all' ? '#0d63f3' : '#f1f5f9',
                color: activeTab === 'all' ? '#ffffff' : '#475569',
              }}
            >
              Tüm Maddeler ({PRIVACY_SECTIONS.length})
            </button>
            {PRIVACY_SECTIONS.map((sec) => (
              <button
                key={sec.id}
                type="button"
                onClick={() => setActiveTab(sec.id)}
                style={{
                  padding: '5px 12px',
                  borderRadius: 20,
                  fontSize: 12,
                  fontWeight: 700,
                  border: 'none',
                  cursor: 'pointer',
                  whiteSpace: 'nowrap',
                  transition: 'all 0.15s ease',
                  background: activeTab === sec.id ? '#0d63f3' : '#f1f5f9',
                  color: activeTab === sec.id ? '#ffffff' : '#475569',
                }}
              >
                {sec.title.split('.')[0]}. {sec.badge}
              </button>
            ))}
          </div>
        </div>

        {/* Modal Scrollable Body */}
        <div
          className="privacy-scroll"
          style={{
            padding: '20px 24px',
            overflowY: 'auto',
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: 20,
          }}
        >
          {filteredSections.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px 20px', color: '#64748b' }}>
              <FiFileText style={{ fontSize: 32, marginBottom: 8, color: '#94a3b8' }} />
              <div style={{ fontSize: 15, fontWeight: 700 }}>Aramanızla eşleşen madde bulunamadı.</div>
              <div style={{ fontSize: 13, marginTop: 4 }}>Lütfen farklı bir arama terimi deneyin veya tüm maddeleri görüntüleyin.</div>
            </div>
          ) : (
            filteredSections.map((sec) => (
              <div
                key={sec.id}
                style={{
                  background: '#ffffff',
                  border: '1px solid #e2e8f0',
                  borderRadius: 14,
                  padding: '18px 20px',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.02)',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: 12,
                    borderBottom: '1px solid #f1f5f9',
                    paddingBottom: 8,
                  }}
                >
                  <h4
                    style={{
                      margin: 0,
                      color: '#061844',
                      fontSize: 15.5,
                      fontWeight: 800,
                      letterSpacing: '-0.01em',
                    }}
                  >
                    {sec.title}
                  </h4>
                  <span
                    style={{
                      fontSize: 11,
                      fontWeight: 700,
                      color: '#0d63f3',
                      background: '#eff6ff',
                      border: '1px solid #dbeafe',
                      padding: '2px 8px',
                      borderRadius: 6,
                    }}
                  >
                    {sec.badge}
                  </span>
                </div>
                {sec.content}
              </div>
            ))
          )}
        </div>

        {/* Modal Footer */}
        <div
          style={{
            padding: '14px 24px',
            borderTop: '1px solid #e2e8f0',
            background: '#f8fafc',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 12,
            flexWrap: 'wrap',
          }}
        >
          <div style={{ color: '#64748b', fontSize: 12, display: 'flex', alignItems: 'center', gap: 6 }}>
            <FiCheckCircle style={{ color: '#059669', fontSize: 14 }} />
            <span>Versiyon 2.4 • Son Güncelleme: 13 Ekim 2026 • 6698 KVKK Kapsamında Yürürlüktedir</span>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <button
              type="button"
              onClick={onClose}
              style={{
                height: 38,
                padding: '0 20px',
                borderRadius: 10,
                border: 'none',
                background: 'linear-gradient(135deg, #0d63f3, #0a4ec4)',
                color: '#ffffff',
                fontWeight: 700,
                fontSize: 13.5,
                cursor: 'pointer',
                boxShadow: '0 6px 16px rgba(13, 99, 243, 0.22)',
                transition: 'all 0.15s ease',
              }}
              onMouseEnter={(e) => (e.currentTarget.style.opacity = '0.92')}
              onMouseLeave={(e) => (e.currentTarget.style.opacity = '1')}
            >
              Okudum, Anladım ve Kapat
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [sifre, setSifre] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [privacyHovered, setPrivacyHovered] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 992);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const prevTitle = document.title;
    document.title = 'ASDER Sistem';
    return () => {
      document.title = prevTitle;
    };
  }, []);

  const handleLogin = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (!email.trim() || !sifre.trim()) {
      toast.error('E-posta ve şifre gerekli');
      return;
    }
    setLoading(true);
    const result = await login(email.trim(), sifre);
    setLoading(false);
    if (result.success) {
      toast.success('Hoş geldiniz!');
      navigate(ROLE_REDIRECT[result.user?.rol] || '/admin/dashboard');
    } else {
      toast.error(result.message || 'Giriş başarısız');
    }
  };


  const inputIconStyle = {
    position: 'absolute',
    left: 18,
    top: '50%',
    transform: 'translateY(-50%)',
    color: '#5d6f91',
    fontSize: 20,
    pointerEvents: 'none',
  };

  return (
    <main style={{
      minHeight: '100vh',
      position: 'relative',
      overflow: 'hidden',
      background: 'linear-gradient(135deg, #f7fbff 0%, #ffffff 45%, #eef6ff 100%)',
      color: '#061844',
      fontFamily: 'var(--font-ui)',
    }}>
      <div style={{ position: 'absolute', top: -190, left: -110, width: 360, height: 360, borderRadius: '50%', background: '#e7f3ff' }} />
      <div style={{ position: 'absolute', top: 34, left: 190, display: 'grid', gridTemplateColumns: 'repeat(3, 9px)', gap: 18, opacity: 0.42 }}>
        {Array.from({ length: 9 }).map((_, i) => <span key={i} style={{ width: 9, height: 9, borderRadius: '50%', background: '#8cbcf4' }} />)}
      </div>
      <div style={{ position: 'absolute', right: '43%', bottom: 78, width: 240, height: 240, borderRadius: '50%', border: '3px dashed rgba(83,157,232,0.24)', borderLeftColor: 'transparent', borderBottomColor: 'transparent', transform: 'rotate(26deg)' }} />
      <div style={{ position: 'absolute', right: '42%', bottom: 224, width: 18, height: 18, borderRadius: '50%', background: '#f2a900' }} />
      <div style={{ position: 'absolute', left: isMobile ? '10%' : '39%', bottom: 84, width: 82, height: 82, background: 'rgba(42,126,231,0.16)', clipPath: 'polygon(0 26%, 100% 0, 75% 100%)', transform: 'rotate(16deg)' }} />
      {!isMobile && (
        <div style={{ position: 'absolute', left: '36%', bottom: 96, width: 270, height: 170, pointerEvents: 'none' }}>
          {[70, 132, 194, 256].map((x, i) => (
            <span key={x} style={{
              position: 'absolute',
              left: x,
              bottom: 0,
              width: 54,
              height: 58 + i * 34,
              borderRadius: 8,
              background: 'linear-gradient(180deg, rgba(99,161,235,0.30), rgba(99,161,235,0.04))',
            }} />
          ))}
          <span style={{ position: 'absolute', left: 0, bottom: 28, width: 280, height: 30, borderRadius: 999, background: 'rgba(69,136,220,0.16)', transform: 'rotate(-28deg)', transformOrigin: 'right center' }} />
        </div>
      )}

      <div style={{
        position: 'relative',
        zIndex: 1,
        minHeight: '100vh',
        display: isMobile ? 'flex' : 'grid',
        flexDirection: isMobile ? 'column' : undefined,
        gridTemplateColumns: isMobile ? undefined : 'minmax(0, 1fr) 420px',
        gap: isMobile ? 24 : 28,
        alignItems: 'center',
        justifyContent: isMobile ? 'flex-start' : 'center',
        padding: isMobile ? '14px 16px 60px' : '20px 30px 70px 40px',
      }}>
        {/* Giriş Bölümü — Mobilde en üstte, sol-sağ üstte logolarla ve ortalı login kartıyla ilk görünen ekran */}
        <div style={{
          width: '100%',
          maxWidth: isMobile ? 440 : 'none',
          margin: isMobile ? '0 auto' : 0,
          minHeight: isMobile ? 'calc(100dvh - 28px)' : 'auto',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: isMobile ? 'space-between' : 'center',
          boxSizing: 'border-box',
          order: isMobile ? 1 : 2,
        }}>
          {/* Mobil Üst Bar: Sol üstte ASDER Sistem, sağ üstte Kare Kurs Vip Bulvar logosu */}
          {isMobile && (
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 10,
              padding: '10px 14px',
              borderRadius: 16,
              background: 'rgba(255,255,255,0.88)',
              border: '1px solid rgba(214, 226, 242, 0.9)',
              boxShadow: '0 12px 28px rgba(30,73,120,0.08)',
              backdropFilter: 'blur(12px)',
              marginBottom: 14,
            }}>
              <AsderBrand compact />
              <div style={{ width: 1, height: 38, background: '#d5dfed', flexShrink: 0 }} />
              <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', flexShrink: 0 }}>
                <KareKursVipLogo compact />
              </div>
            </div>
          )}

          {/* Ortalı Login Kartı */}
          <aside style={{
            width: '100%',
            margin: isMobile ? 'auto 0' : 0,
            padding: isMobile ? '26px 20px' : '30px 34px',
            borderRadius: isMobile ? 20 : 14,
            background: 'rgba(255,255,255,0.88)',
            border: '1px solid rgba(222,229,239,0.92)',
            boxShadow: '0 22px 54px rgba(8,36,76,0.14)',
            backdropFilter: 'blur(18px)',
            boxSizing: 'border-box',
          }}>
            <div style={{ marginBottom: 20, textAlign: isMobile ? 'center' : 'left' }}>
              <h2 style={{ margin: 0, color: '#061844', fontSize: isMobile ? 26 : 30, fontWeight: 900, letterSpacing: '-0.02em' }}>Giriş Yap</h2>
              <p style={{ margin: '8px 0 0', color: '#53698d', fontSize: 14 }}>Hesabınıza erişmek için bilgilerinizi girin</p>
            </div>

            <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              <div>
                <label className="form-label" style={{ color: '#061844', fontSize: 13, fontWeight: 900, marginBottom: 7 }}>E-posta</label>
                <div style={{ position: 'relative' }}>
                  <FiMail style={inputIconStyle} />
                  <input
                    type="email"
                    className="form-input"
                    placeholder="ornek@email.com"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    autoComplete="email"
                    style={{ height: 46, paddingLeft: 46, borderRadius: 9, background: 'rgba(255,255,255,0.68)', borderColor: '#cfd8e6' }}
                  />
                </div>
              </div>
              <div>
                <label className="form-label" style={{ color: '#061844', fontSize: 13, fontWeight: 900, marginBottom: 7 }}>Şifre</label>
                <div style={{ position: 'relative' }}>
                  <FiLock style={inputIconStyle} />
                  <input
                    type={showPassword ? 'text' : 'password'}
                    className="form-input"
                    placeholder="••••••••"
                    value={sifre}
                    onChange={e => setSifre(e.target.value)}
                    autoComplete="current-password"
                    style={{ height: 46, paddingLeft: 46, paddingRight: 48, borderRadius: 9, background: 'rgba(255,255,255,0.68)', borderColor: '#cfd8e6' }}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(v => !v)}
                    aria-label={showPassword ? 'Şifreyi gizle' : 'Şifreyi göster'}
                    style={{
                      position: 'absolute',
                      right: 12,
                      top: '50%',
                      transform: 'translateY(-50%)',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      padding: 6,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: showPassword ? '#0d63f3' : '#5d6f91',
                      fontSize: 20,
                    }}
                  >
                    {showPassword ? <FiEyeOff /> : <FiEye />}
                  </button>
                </div>
              </div>

              <button
                type="submit"
                className="btn btn-primary btn-lg"
                style={{
                  width: '100%',
                  height: 46,
                  justifyContent: 'center',
                  marginTop: 2,
                  borderRadius: 10,
                  background: 'linear-gradient(135deg, #f3122d, #de0625)',
                  boxShadow: '0 16px 30px rgba(237,27,53,0.24)',
                  fontSize: 15,
                  fontWeight: 900,
                }}
                disabled={loading}
              >
                {loading ? (
                  <><div className="spinner" style={{ width: 15, height: 15 }} />&nbsp;Giriş yapılıyor...</>
                ) : 'Giriş Yap →'}
              </button>
            </form>

            {/* Google Play ve App Store İndirme Butonları */}
            <div style={{
              marginTop: 20,
              paddingTop: 18,
              borderTop: '1px solid rgba(207, 216, 230, 0.7)',
            }}>
              <StoreDownloadBadges compact />
            </div>
          </aside>

          {isMobile && (
            <div style={{
              textAlign: 'center',
              marginTop: 14,
              paddingBottom: 4,
              fontSize: 12,
              fontWeight: 600,
              color: '#5d6f91',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 6,
              opacity: 0.85,
            }}>
              <span>Özellikler ve detaylar için aşağı kaydırın</span>
              <span style={{ fontSize: 14 }}>↓</span>
            </div>
          )}
        </div>

        {/* Tanıtım / Özellikler Bölümü — Mobilde aşağı kaydırılınca görünür, masaüstünde solda */}
        <section style={{
          maxWidth: isMobile ? 440 : 780,
          width: '100%',
          margin: isMobile ? '24px auto 0' : 0,
          order: isMobile ? 2 : 1,
        }}>
          {!isMobile && (
            <div style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: 26,
              marginBottom: 22,
            }}>
              <div style={{
                padding: '16px 24px',
                borderRadius: 22,
                background: 'rgba(255,255,255,0.72)',
                boxShadow: '0 18px 44px rgba(30,73,120,0.08)',
              }}>
                <AsderBrand small={false} />
              </div>
              <div style={{ width: 1, height: 96, background: '#cfd8e6' }} />
              <KareKursVipLogo small={false} />
            </div>
          )}

          <h1 style={{
            margin: 0,
            color: '#061844',
            fontSize: isMobile ? 32 : 40,
            lineHeight: 1.08,
            fontWeight: 900,
            letterSpacing: '-0.02em',
          }}>
            Öğrencilerin<br />
            <span style={{ color: '#ed1b35', fontStyle: 'italic' }}>başarısı</span> için
          </h1>
          <p style={{
            margin: isMobile ? '14px 0 22px' : '14px 0 24px',
            color: '#455b80',
            fontSize: isMobile ? 14 : 15,
            lineHeight: 1.75,
            maxWidth: 640,
          }}>
            Yoklama, deneme analizi, rehberlik görüşmeleri ve daha fazlası<br />
            — tüm yönetim araçları tek platformda.
          </p>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, minmax(86px, 150px))',
            gap: isMobile ? 12 : 22,
            marginBottom: isMobile ? 22 : 22,
          }}>
            {[['7', 'Rol'], ['60+', 'API'], ['∞', 'Öğrenci']].map(([n, l], i) => (
              <div key={l} style={{
                borderRight: !isMobile && i < 2 ? '1px solid #d6deea' : 'none',
                minHeight: 54,
              }}>
                <div style={{ color: '#ed1b35', fontSize: isMobile ? 26 : 30, fontWeight: 900, lineHeight: 1 }}>{n}</div>
                <div style={{ marginTop: 6, color: '#52698d', fontSize: 13, fontWeight: 500 }}>{l}</div>
              </div>
            ))}
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, minmax(260px, 1fr))',
            gap: 16,
            maxWidth: 700,
          }}>
            {[
              { t: 'Canlı Takip', d: 'Yoklama, ödev ve deneme süreçlerini tek ekranda takip edin.', icon: <FiBarChart2 /> },
              { t: 'Hızlı Karar', d: 'Ölçme sonuçlarıyla doğru öğrencide doğru aksiyonu alın.', icon: <FiCheck /> },
            ].map((item, idx) => (
              <div key={item.t} style={{
                display: 'grid',
                gridTemplateColumns: '42px 1fr',
                gap: 12,
                alignItems: 'center',
                padding: '14px 16px',
                borderRadius: 14,
                background: 'rgba(255,255,255,0.82)',
                border: '1px solid rgba(202,214,231,0.84)',
                boxShadow: '0 14px 34px rgba(26,63,108,0.09)',
              }}>
                <div style={{
                  width: 42,
                  height: 42,
                  borderRadius: '50%',
                  display: 'grid',
                  placeItems: 'center',
                  color: idx === 0 ? '#1266f1' : '#04b878',
                  background: idx === 0 ? '#eaf3ff' : '#dff8ec',
                  fontSize: 20,
                }}>
                  {item.icon}
                </div>
                <div>
                  <div style={{ color: '#1266f1', fontSize: 15, fontWeight: 900 }}>{item.t}</div>
                  <div style={{ marginTop: 5, color: '#40577b', fontSize: 13, lineHeight: 1.42 }}>{item.d}</div>
                </div>
              </div>
            ))}
          </div>

          {/* Gizlilik Sözleşmesi Bölümü */}
          <div style={{ marginTop: isMobile ? 18 : 22, maxWidth: 700 }}>
            <button
              type="button"
              onClick={() => setShowPrivacyModal(true)}
              onMouseEnter={() => setPrivacyHovered(true)}
              onMouseLeave={() => setPrivacyHovered(false)}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 10,
                background: privacyHovered ? 'rgba(13, 99, 243, 0.08)' : 'rgba(255, 255, 255, 0.85)',
                border: `1.5px solid ${privacyHovered ? '#0d63f3' : 'rgba(13, 99, 243, 0.28)'}`,
                padding: '10px 18px',
                borderRadius: 22,
                color: '#0d63f3',
                fontSize: 14,
                fontWeight: 700,
                cursor: 'pointer',
                boxShadow: privacyHovered ? '0 6px 20px rgba(13, 99, 243, 0.16)' : '0 4px 14px rgba(13, 99, 243, 0.06)',
                backdropFilter: 'blur(10px)',
                WebkitBackdropFilter: 'blur(10px)',
                transition: 'all 0.22s ease',
              }}
            >
              <FiShield style={{ fontSize: 16, color: '#0d63f3', flexShrink: 0 }} />
              <span style={{ letterSpacing: '-0.01em' }}>Gizlilik Sözleşmesi ve KVKK Aydınlatma Metni</span>
              <FiArrowRight
                style={{
                  fontSize: 16,
                  color: '#0d63f3',
                  transform: privacyHovered ? 'translateX(4px)' : 'translateX(0)',
                  transition: 'transform 0.22s ease',
                  flexShrink: 0,
                }}
              />
            </button>
          </div>
        </section>
      </div>

      {!isMobile && (
        <footer style={{
          position: 'absolute',
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 0,
          height: 78,
          color: '#fff',
          background: '#062653',
          clipPath: 'ellipse(82% 70% at 54% 100%)',
        }}>
          <div style={{
            position: 'absolute',
            left: 0,
            top: 24,
            width: 280,
            height: 28,
            background: '#f7aa00',
            transform: 'rotate(9deg)',
            transformOrigin: 'left center',
          }} />
          <div style={{ position: 'absolute', right: 48, bottom: 14, width: 128, padding: '5px 8px', borderRadius: 8, background: '#fff' }}>
            <KareKursVipLogo small />
          </div>
        </footer>
      )}

      {/* Detaylı Gizlilik Sözleşmesi ve KVKK Modalı */}
      <PrivacyModal
        isOpen={showPrivacyModal}
        onClose={() => setShowPrivacyModal(false)}
      />
    </main>
  );
}
